import { toast } from 'react-toastify';
const notify = {
    error: (message) => toast.error(message),
    warn: (message) => toast.warn(message),
    success: (message) => toast.success(message),
    info: (message) => toast.info(message),
};
export default notify;
